export default __webpack_public_path__ + "static/media/IEE.1fe53957.pdf";